<template>
  <div>
    <div class="features_items">
      <div v-if="products.productGroups.length === 0">
        <h2>No Products Found</h2>
        <p>The site not been able to find any products to display.</p>
      </div>
      <div v-else-if="products.productGroups.length === 1 && isHomepage === true">
        <h2 class="title text-center">{{products.productGroups[0].description}}</h2>
        <template v-for="productCategory in products.productGroups[0].productCategories">
          <product-cateogry-item :productCategory="productCategory" :groupSlug="products.productGroups[0].slug" v-bind:key="productCategory.productCategoryId" ></product-cateogry-item>
        </template>
      </div>
      <div v-else>
        <h2 class="title text-center" v-if="isHomepage === true">Online Shop</h2>
        <h1 v-else >Online Shop</h1>
        <template v-for="productGroup in products.productGroups">
          <product-group-item :productGroup="productGroup" v-bind:key="productGroup.productGroupId" ></product-group-item>
        </template>
      </div>
    </div>
    <div>
      <productItems v-if="isHomepage !== true"></productItems>
    </div>
  </div>
</template>

<script>
import ProductCategoryItem from './ProductCategoryItem';
import ProductGroupItem from './ProductGroupItem';
import ProductItems from './ProductItems';

export default {
  name: 'product-groups',
  props: ['isHomepage'],
  created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },
  computed: {
    products() {
      return this.$store.getters.allProducts;
    },
  },
  components: {
    'product-cateogry-item': ProductCategoryItem,
    'product-group-item': ProductGroupItem,
    'product-items': ProductItems,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/products/ProductGroups.vue